{% block sw_cms_page_form_section_name_wrapper %}
    {% parent %}

    {% block sw_cms_page_form_block_rules %}
        <div
            v-if="sectionHasRulesOnAllBlocks(section)"
            class="sw-cms-page-form__section-action sw-cms-page-form__section-anchor"
        >
            {% block sw_cms_page_form_block_rules_icon %}
                <mt-icon
                    class="sw-cms-page-form__section-action-icon sw-cms-page-form__block-rules-icon"
                    name="solid-question-circle"
                    size="20"
                />
            {% endblock %}

            {% block sw_cms_page_form_block_rules_text %}
                <span class="sw-cms-page-form__section-action-label sw-cms-page-form__block-rules-label">
                    {{ $tc('swag-cms-extensions.sw-cms.sidebar.rulesOnAllBlocks') }}
                </span>
            {% endblock %}
        </div>
    {% endblock %}

    {% block sw_cms_page_form_section_anchor %}
        <div
            v-if="getScrollNavigationBySection(section)?.active"
            class="sw-cms-page-form__section-action sw-cms-page-form__section-anchor"
        >
            {% block sw_cms_page_form_section_anchor_icon %}
                <mt-icon
                    class="sw-cms-page-form__section-action-icon sw-cms-page-form__section-anchor-icon"
                    name="regular-tag"
                    size="20"
                />
            {% endblock %}

            {% block sw_cms_page_form_section_anchor_text %}
                <span class="sw-cms-page-form__section-action-label sw-cms-page-form__section-anchor-label">
                    {{ getScrollNavigationLabel(section) }}
                </span>
            {% endblock %}
        </div>
    {% endblock %}
{% endblock %}
